module.exports = __webpack_public_path__ + "img/shipo-icon-radar.654544dd.svg";